import { liveTrackingConfig } from '../configs/LiveTrackingConfig';
import { createLiveSchemaEventFactoryNew, TSchemaEventFactoryNew } from './helpers/utils';

/**
 * Engagement chat tracking.
 *
 * @link https://big-picture.vimeows.com/events/details/vimeo.live_engagement_chat
 */
const trackEngagementChat: TSchemaEventFactoryNew = createLiveSchemaEventFactoryNew(
  'vimeo.live_engagement_chat',
  2,
  () => ({
    ...liveTrackingConfig.BIG_PICTURE_INTERACTION_SCHEMA_BASE,
  }),
);

export function trackEnableAudienceChat(): void {
  return trackEngagementChat({ eventName: 'enable_audience_chat' });
}

export function trackDisableAudienceChat(): void {
  return trackEngagementChat({ eventName: 'disable_audience_chat' });
}

export function trackViewChat(): void {
  return trackEngagementChat({ eventName: 'view_chat', eventType: 'impression' });
}

export function trackSendMessage(): void {
  return trackEngagementChat({ eventName: 'send_message' });
}

export function trackBanUser(): void {
  return trackEngagementChat({ eventName: 'ban_user' });
}

export function trackSendBackstageMessage(): void {
  return trackEngagementChat({ eventName: 'send_backstage_message' });
}

export function trackDeleteMessage(): void {
  return trackEngagementChat({ eventName: 'delete_message' });
}

export function trackDeleteBackstageMessage(): void {
  return trackEngagementChat({ eventName: 'delete_backstage_message' });
}

export function trackExportChat(): void {
  return trackEngagementChat({ eventName: 'export_chat' });
}
